import React from 'react';
import AutoHotspotsAnimationFab from '../../components/fab/auto-hotspot-animation-fab';

type PropTypes = {
  data: any;
  handleClickHotspot: any;
};

export default function AutoHotspots(props: PropTypes) {
  const { data, handleClickHotspot } = props;

  const clickHotspot = (event: any) => {
    handleClickHotspot(event, data, 'auto');
  };

  return (
    <AutoHotspotsAnimationFab onClick={(event: any) => clickHotspot(event)} />
  );
}
